import React, { useState, useEffect } from 'react';
import { ReactComponent as Close } from '../../../assets/images/teamclose.svg';
import './style.css';
import Input from '../../common/InputField';
import { createCannedMsg } from '../../../store/features/createCannedMsg';
import { updateCannedMsg } from '../../../store/features/updateCannedMsg';

import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import TextArea from 'antd/es/input/TextArea';

function CannedPopup({ selectedMsg, setSelectedMsg, cannedPrivate, cannedMsg, cannedTag, setCannedResponse, getCanned }) {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.loginToken);

  const [activeCanned, setActiveCanned] = useState(cannedPrivate ? 'Private' : 'Shared');
  const [responseText, setResponseText] = useState(cannedMsg || '');
  const [isPrivate, setIsPrivate] = useState(cannedPrivate ? true : false);
  const [tag, setTag] = useState(cannedTag || '');

  useEffect(() => {
    setResponseText(cannedMsg);
  }, [cannedMsg]);

  const handleViewChange = (newView) => {
    setActiveCanned(newView);
    const isPrivate = newView !== 'Shared';
    setIsPrivate(isPrivate)
  };
  
  const handleCreateCannedMsg = async () => {
    const listCoUserList = dispatch(
      createCannedMsg({
        requestHeaders: { 
          content: responseText, 
          tagName: tag,
          business_id: userData?.response?.user?.business_id,
          is_private: isPrivate,
          in_business: !isPrivate
          },
      }),
    );
    listCoUserList
      .then(async (data) => {
        if (!data.payload) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.success) {
          setResponseText('');
          setTag('');
          setCannedResponse(false);
          getCanned();
           toast.success('Canned message created successfully', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else {
          toast.error('Canned message already exists for this tag', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  }

  const handleUpdateCannedMsg = async () => {
    const listCoUserList = dispatch(
      updateCannedMsg({
        id: selectedMsg,
        requestHeaders: { 
          content: responseText, 
          tagName: tag,
          business_id: userData?.response?.user?.business_id,
          is_private: isPrivate,
          in_business: !isPrivate
          },
      }),
    );
    listCoUserList
      .then(async (data) => {
        if (!data.payload) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.success) {
          setResponseText('');
          setTag('');
          setActiveCanned('Shared')
          setCannedResponse(false);
          getCanned();
          setSelectedMsg('')
           toast.success('Canned message updated successfully', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else {
          toast.error('Canned message already exists for this tag', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  }

  const handleTagChange = (e) => {
    const value = e.target.value;

  // Remove the '#' character if it exists before saving
  if (value.startsWith('#')) {
    setTag(value.slice(1)); 
  } else {
    setTag(value);
  }
  };

  const isSaveDisabled = !responseText.trim() || !tag.trim() || tag.length > 15;

  return (
    <>
      <div className="overlay" />
      <div className="Canned-PopUp-Container">
        <div className="Team-PopUp-Header">
          <p className="PopUp-Text01">Save reply as canned response</p>
          <p className="PopUp-Text02" onClick={() => setCannedResponse(false)}>
            <Close />
          </p>
        </div>
        <div className="ChatAgent-Main-Container">
          <p
            className={`chats-text ${
              activeCanned === 'Shared' ? 'activeChat' : ''
            }`}
            onClick={() => handleViewChange('Shared')}
          >
            Shared
          </p>
          <p
            className={`Archive-text ${
              activeCanned === 'Private' ? 'activeChat' : ''
            }`}
            onClick={() => handleViewChange('Private')}
          >
            Private
          </p>
        </div>
        <p className="PopUp-Canned-Text">
          {activeCanned === 'Private' 
            ? 'Only you will have access to this canned response.'
            : 'All group members will have access to this canned response.'}
        </p>
        <div className="Caneed-responseInput-Container">
          <p className="chat-txt">Response text</p>
          <TextArea
            placeholder=""
            title="Response text"
            className="canned-Input"
            value={responseText}
            rows={3}
            onChange={(e) => setResponseText(e.target.value)}
          />
          <br /><br />
          <Input 
            title="Shortcuts" 
            placeholder="# Type"
            value={`${tag}`}
            onChange={handleTagChange}
          />
          {/* <p className="chat-txt" style={{color: '#93A1B0'}}>Hit enter to add</p> */}
        </div>
        <div className="PopUp-Canned-footer">
          <p className="Canned-Advance-text">
            {/* Advanced Setting */}
          </p>
          <div className="PopUpCanned-button">
            <button
              className="Canned-Cancel"
              type="button"
              onClick={() => setCannedResponse(false)}
            >
              Cancel
            </button>
            {selectedMsg ? <button 
              className="Canned-Save" 
              type="button"
              onClick={handleUpdateCannedMsg}
              disabled={isSaveDisabled} 
            >
              Update
            </button> :
            <button 
              className="Canned-Save" 
              type="button"
              onClick={handleCreateCannedMsg}
              disabled={isSaveDisabled} 
            >
              Save
            </button>
            }
            
          </div>
        </div>
      </div>
    </>
  );
}

export default CannedPopup;
